var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFactory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512.003,
    height: 512.003,
    viewBox: "0 0 512.003 512.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m105.002 94.939c33.219-1.373 44.419-25.538 44.966-40.796h59.555c-16.296.141-29.522 13.726-29.522 30 0 16.569 13.431 30 30 30v30.358h30.001v-49.563c11.146 4.476 22.182 3.597 33.17-1.259 2 30.913 27.702 55.368 59.12 55.368 19.289 0 36.423-9.219 47.242-23.49 13.061 14.978 32.284 24.445 53.718 24.445 39.35 0 71.25-31.9 71.25-71.25s-31.9-71.25-71.25-71.25c-27.001 0-50.493 15.021-62.579 37.161-10.34-8.801-23.739-14.115-38.381-14.115-12.543 0-24.173 3.901-33.75 10.551-5.049-19.331-22.628-33.596-43.541-33.596h-135c-25.515 0-45.881 21.161-44.967 46.641-16.529-.143-30.033 13.557-30.033 30 0 16.569 13.431 30 30 30v30.359h30.001zm317.398 197.406c16.59 0 30.038-13.449 30.038-30.038 0-17.42-14.73-31.124-32.072-29.968 4.142-24.277-14.483-46.647-39.317-46.647-22.031 0-39.89 17.859-39.89 39.89 0 26.831 25.905 45.756 51.241 38.249.794 15.882 13.922 28.514 30 28.514z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m55.501 264.501h69.001l-4.5-59.999h-60.001z",
    fill: "#717f98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.501 504.502h105l-18-240.001h-69zm22.5-300h60.001v-60.001h-60.001z",
    fill: "#717f98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.502 504.502h29.999l11.25-150h-52.499z",
    fill: "#b0c5e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.501 504.502h197.001v-180l-103.25 29.5v-29.5l-105.001 30z",
    fill: "#e5ecf5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.501 264.501h22.5l4.5-59.999h-22.5z",
    fill: "#717f98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.501 504.502h22.5l18-240.001h-22.5zm22.5-300h22.5v-60.001h-22.5z",
    fill: "#717f98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.501 504.502h105l-18-240.001h-69zm135 0h105l-18-240.001h-69zm22.5-300h60.001v-60.001h-60.001zm-135 0h60.001v-60.001h-60.001z",
    fill: "#5dffe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.501 264.501h69l-4.5-59.999h-60.001zm-135 0h69l-4.5-59.999h-60z",
    fill: "#e5ecf5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.501 264.501h22.5l4.5-59.999h-22.5zm135 0h22.5l4.5-59.999h-22.5z",
    fill: "#717f98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.501 504.502h22.5l18-240.001h-22.5zm135 0h22.5l18-240.001h-22.5zm22.5-300h22.5v-60.001h-22.5zm-135 0h22.5v-60.001h-22.5z",
    fill: "#00e1be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.501 504.502h22.5l-11.871-156.251-21.878 6.251zm93.751 0h22.5v-156.929l-22.5 6.428z",
    fill: "#b0c5e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.001 122.001v22.5h30.001v-22.5zm182.319 65.296c-25.324-7.416-51.16 11.484-51.16 38.285 0 26.806 25.857 45.72 51.171 38.269-16.147-4.785-28.671-19.614-28.671-38.269-.001-18.131 12.097-33.434 28.66-38.285zm-119.149-93.618c2 30.913 27.702 55.368 59.12 55.368 19.289 0 36.423-9.219 47.242-23.49 13.061 14.978 32.284 24.445 53.718 24.445 44.005 0 77.206-39.366 70.363-82.5-9.521 60.017-93.873 70.767-124.081 28.056-20.858 47.304-84.34 42.823-106.362-1.879zm-198.17 50.824h30.001v-22.5h-30.001z",
    fill: "#9a999d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.439 225.272c-.072-11.007-3.973-21.712-11.199-30.275-9.012-10.68-22.203-16.805-36.191-16.805-26.131 0-47.39 21.259-47.39 47.39 0 15.078 6.931 28.9 19.016 37.924 9.854 7.358 21.767 10.548 33.639 9.193 4.511 15.753 19.004 27.146 36.085 27.146 20.699 0 37.539-16.839 37.539-37.538 0-10.501-4.219-20.232-11.88-27.399-5.458-5.108-12.328-8.437-19.619-9.636zm-6.039 59.573c-12.022 0-21.91-9.395-22.509-21.389l-.476-9.527-9.146 2.71c-9.88 2.93-20.312 1.05-28.62-5.153-8.255-6.164-12.99-15.606-12.99-25.905 0-17.86 14.53-32.39 32.39-32.39 9.559 0 18.571 4.184 24.727 11.479 6.187 7.331 8.81 16.956 7.197 26.408l-1.6 9.377 9.491-.632c6.31-.42 12.333 1.724 16.946 6.039 4.596 4.3 7.127 10.141 7.127 16.446.002 12.427-10.109 22.537-22.537 22.537z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.002 384.001h15v98h-15z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.002 384.001h15v98h-15z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.752 384.001h15v98h-15z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.752 384.001h15v98h-15z",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/factory.368bcbb9634e5717b9dcef2909c090a9.svg";
export { ForwardRef as ReactComponent };